import { render, staticRenderFns } from "./PeopleInfo.vue?vue&type=template&id=0b525817&scoped=true"
import script from "./PeopleInfo.vue?vue&type=script&lang=ts"
export * from "./PeopleInfo.vue?vue&type=script&lang=ts"
import style0 from "./PeopleInfo.vue?vue&type=style&index=0&id=0b525817&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b525817",
  null
  
)

export default component.exports